// use common.js, so we can consume the config modules in the build flow
module.exports = {
  __mcFeatureBEurl: {
    "qa": 'mcfeature-qa.dev.lprnd.net',
    "z0": 'mcfeature-qa.dev.lprnd.net',
    // "z1-a": 'z1-a.mcfeature.liveperson.net',
    "z1-a": 'va-a.mcfeature.liveperson.net', // FIXME Temporary change z1-a to request va
    "z1": 'z1.mcfeature.liveperson.net',
    "z2": 'z2.mcfeature.liveperson.net',
    "z3": 'z3.mcfeature.liveperson.net',
    "default": 'z1.mcfeature.liveperson.net',
  }
};
